define.alias("shared/components/shared/pre-boarding/survey-components/text-input", "settings/components/shared/pre-boarding/survey-components/text-input");